import vtkConcentricCylinderSource from './ConcentricCylinderSource';
import vtkConeSource from './ConeSource';
import vtkCubeSource from './CubeSource';
import vtkImageGridSource from './ImageGridSource';
import vtkLineSource from './LineSource';
import vtkPlaneSource from './PlaneSource';
import vtkPointSource from './PointSource';
import vtkRTAnalyticSource from './RTAnalyticSource';
import vtkSLICSource from './SLICSource';
import vtkSphereSource from './SphereSource';
import vtkCursor3D from './Cursor3D';

export default {
  vtkConcentricCylinderSource,
  vtkConeSource,
  vtkCubeSource,
  vtkImageGridSource,
  vtkLineSource,
  vtkPlaneSource,
  vtkPointSource,
  vtkRTAnalyticSource,
  vtkSLICSource,
  vtkSphereSource,
  vtkCursor3D,
};
